import { IError } from './IError';
import { IResult } from './IResponse';
import { IUser } from './IUser';

export interface IResultCodes {
  id: string;       // the item these result codes apply to.
  codes: number[];  // the result codes for the specified item.
}

export interface IUserActionError extends IError {
  username?: string;
}

export interface IUserActionResult extends IResult {
  users?: IUser[];
  results?: IResultCodes[];
}

export let UserActionResultCode = {
  systemUserCreated : '10',
  siteUserCreated : '12',
  siteRoleAssigned : '30',
  userForcedPasswordUpdate: '61',
  userResetLoginRateLimiting: '62',
};
